(function() {
    'use strict';
 
a3_pilot_reports.factory('ServerCabinReportFactory',ServerCabinReportFactory)

/* @ngInject */ 
function ServerCabinReportFactory($log,GenericService){

		function ServerCabinReport() {
			this.AuthorAimsId = null;
			this.AuthorName = null;
			this.Created = null;
			this.FlightAimsId = null;
			this.FlightId=null;
			this.LastUpdated = null;
			this.ReportGuid = null;
			this.ReportId = null;
			this.getDescription = getDescription;
		}

		function getDescription() {
			if (this.Created == null && this.AuthorName == null) return '-null-';
			else return (this.Created || '?') + ' - ' + (this.AuthorName || '?');
		}
		
		var objCallback = ServerCabinReport;

		var service = {
				fromObjectList : fromObjectList,
		}

		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList,objCallback);
		}
	
	return service;
	}

 })();   